import { render, staticRenderFns } from "./ShowLeft.vue?vue&type=template&id=5643dde8&scoped=true&"
import script from "./ShowLeft.vue?vue&type=script&lang=js&"
export * from "./ShowLeft.vue?vue&type=script&lang=js&"
import style0 from "./ShowLeft.vue?vue&type=style&index=0&id=5643dde8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643dde8",
  null
  
)

export default component.exports